import React from "react";
import {Field, reduxForm} from "redux-form";
import validator from 'validator';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';


class LoginForm extends React.Component {

    renderTextField = ({
        label,
        input,
        meta: { touched, invalid, error },
        ...custom
      }) => (
        <TextField
          label={label}
          placeholder={label}
          error={touched && invalid}
          helperText={touched && error}
          {...input}
          {...custom}
        />
    )

    onSubmit = (formValues) => {
        this.props.onSubmit(formValues);
    } 

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                <Field 
                    name="email"
                    id="email"
                    component={this.renderTextField} 
                    label="Email Address"
                    autoComplete="email"
                    // autoFocus
                    margin="normal"
                    required
                    fullWidth
                />
                <Field 
                    name="password"
                    id="password"
                    component={this.renderTextField} 
                    label="Password"
                    type="password"
                    autoComplete="current-password"
                    // autoFocus
                    margin="normal"
                    required
                    fullWidth
                />                
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Log in
                </Button>
            </form>
        )
    }
}

const validate = (formValues) => {
    const errors = {};

    if (!formValues.email) {
        errors.email = 'You must enter a email';    
    }

    if (formValues.email) {
        if (!validator.isEmail(formValues.email)) {
            errors.email = 'You must enter a valid email';    
        }
    }    

    if (!formValues.password) {
        errors.password = 'You did not enter a password';
    }

    // if (formValues.password) {
    //     if (!validator.isStrongPassword(formValues.password, {
    //         minLength: 8,
    //       })) {
    //         errors.password = 'Password must be at least 8 characters long'
    //     }
    // }

    return errors;
};

export default reduxForm({
    form: 'loginForm',
    validate: validate
})(LoginForm);